<!-- =========================================================================================
  File Name: FormWizardValidation.vue
  Description: Form wizard with validation
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>
    <div class="vx-row" v-if="stages">
       <div class="vx-col w-full sm:w-1/3 md:w-1/3 lg:w-1/3 xl:w-1/3 mb-base">
        <statistics-card-line
          hideChart
          class="mb-base"
          icon="SearchIcon"
          icon-right
          :statistic="stages.contractPreparation"
          statisticTitle="Confecção do Contrato"
          :color="color"
        />
      </div>

      <div class="vx-col w-full sm:w-1/3 md:w-1/3 lg:w-1/3 xl:w-1/3 mb-base">
        <statistics-card-line
          hideChart
          class="mb-base"
          icon="PackageIcon"
          icon-right
          :statistic="stages.installed"
          statisticTitle="Instalado"
          :color="color"
        />
      </div>
     <div class="vx-col w-full sm:w-1/3 md:w-1/3 lg:w-1/3 xl:w-1/3 mb-base">
        <statistics-card-line
          hideChart
          class="mb-base"
          icon="DollarSignIcon"
          icon-right
          :statistic="stages.contractSubmitted"
          statisticTitle="Contrato Enviado"
          :color="color"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { numberJS } from "@/helpers";
import StatisticsCardLine from "@/components/statistics-cards/StatisticsCardLine.vue";
export default {
  components: {
    StatisticsCardLine,
  },
  data() {
    return {
      totalOrder: 0,
      stages: null,
      color: null,
    };
  },
  methods: {
    showPercentageStage(orders, color) {
      this.color = color;
      let stages = {};
      let contractPreparation = 0;
      let installed = 0;
      let contractSubmitted = 0;
      let contractFiled = 0;

      for (let order of orders) {
        if (order.stage == "Confecção do Contrato") {
          contractPreparation++;
        }
        if (order.stage == "Instalado") {
          installed++;
        }
        if (order.stage == "Contrato Enviado") {
          contractSubmitted++;
        }
        if (order.stage == "Contrato Arquivado") {
          contractFiled++;
        }
      }

      let totalStages = contractPreparation + installed + contractSubmitted + contractFiled;
      let percContractPreparation = (contractPreparation * 100) / totalStages;
      let percInstalled = (installed * 100) / totalStages;
      let percContractSubmitted = (contractSubmitted * 100) / totalStages;
      let perContractFiled = (contractFiled * 100) / totalStages;

      stages.contractPreparation = numberJS().formatPercent(percContractPreparation) + "%";
      stages.installed = numberJS().formatPercent(percInstalled) + "%";
      stages.contractSubmitted = numberJS().formatPercent(percContractSubmitted) + "%";
      stages.contractFiled = numberJS().formatPercent(perContractFiled) + "%";
      this.stages = stages;
    },
  },
  created() {
    
  },
  mounted() {},
};
</script>
